import { PlusIcon } from '@phosphor-icons/react';
import { Button } from 'components/button/Button';
import { Card } from 'components/Card';
import { Formik } from 'components/form/formik';
import diff from 'object-diff';
import { useMemo } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
import { captureException } from '@sentry/react';

import { InputField } from '../../../components/input/InputField';
import { updateGeneralSettings } from '../models';
import { getDisplayError } from '../../../utils/get-display-error';
import { useAllGeneralSettings } from '../all-settings-context';

const billitSettingsSchema = Yup.object().shape({
  billitApiRootUrl: Yup.string().required('Vereist'),
  billitApiToken: Yup.string().required('Vereist'),
  billitPartyId: Yup.string().required('Vereist'),
});

interface IBillitSettingsValues {
  billitApiRootUrl: string;
  billitApiToken: string;
  billitPartyId: string;
}

export const BillitSettingsPage = () => {
  const { settings } = useAllGeneralSettings();

  const initialValues: IBillitSettingsValues = useMemo(() => {
    return {
      billitApiRootUrl: settings.billitApiRootUrl ?? 'https://api.billit.be',
      billitPartyId: settings.billitPartyId ?? '',
      billitApiToken: '',
    };
  }, [settings]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={billitSettingsSchema}
      onSubmit={async (values) => {
        try {
          const patch: Partial<typeof values> = diff(initialValues, values);
          await updateGeneralSettings(patch);
          toast.success('Billit instellingen aangepast');
        } catch (err: any) {
          captureException(err);
          toast.error('Kon billit instellingen niet aanpassen: ' + getDisplayError(err));
        }
      }}
    >
      {({ handleSubmit, isSubmitting }) => {
        return (
          <form onSubmit={handleSubmit} className="grid gap-4">
            <Card title="API verbinding" subtitle="Gegevens van het Billit boekhoudplatform waarmee wordt gesynct.">
              <InputField labelText="Billit API Root URL" type="text" name="billitApiRootUrl" />
              <InputField labelText="Billit Party ID" type="text" name="billitPartyId" />
              <InputField labelText="Billit API Token" type="text" name="billitApiToken" />
            </Card>

            <div>
              <Button
                type="submit"
                color="primary"
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                iconLeft={<PlusIcon className="button-icon" />}
              >
                Pas instellingen aan
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
